import { createAction } from '@reduxjs/toolkit';
// (`stopSubmit` from redux-form was used here to surface per-field
// error maps on rename failures. After the RHF migration in Epic
// 13e the per-field error display goes via the form's local
// useEffect+setError; the snackbar at the top of the page still
// covers the catch-all error path.)
import { call, put, takeEvery } from '@redux-saga/core/effects';
import { deleteItem as deleteDialog } from "../dialog-manager/actions";
import { addItem as notify } from "../notifications/actions";
import { initialState as commonInitialState } from '../../utils/redux/commonActionHandlers';
import Api from '../../utils/Api';

const constantsPrefix = 'USER-DOCUMENTS';
const statePropName = 'userDocuments';

const extendedConstants = (baseConstants) => ({
  ...baseConstants,
  SET_SELECTED_TYPES: `${constantsPrefix}/SET_SELECTED_TYPES`,
  RENAME_FILES: `${constantsPrefix}/RENAME_FILES`,
});

const extendedActions = (baseActions, constants) => ({
  ...baseActions,
  renameFiles: createAction(constants.RENAME_FILES),
  setSelectedTypes: (payload) => ({ type: constants.SET_SELECTED_TYPES, payload }),
});

const extendedInitialState = {  
  ...commonInitialState,
  selectedTypes: null,
};

const extendedActionHandlers = (baseActionHandlers, constants) => ({
  ...baseActionHandlers,
  [constants.CLEAR_FILTER]: (state) => ({ ...state, filter: { ...extendedInitialState.filter } }),
  [constants.SET_SELECTED_TYPES]: (state, { payload }) => ({ ...state, selectedTypes: payload }),
});

const newSagas = (baseSagas, constants, actions) => {
  function* renameFiles({ payload: ids }) {
    try {
      yield call(Api.applicantDocuments.renameFiles, ids);
      yield put(deleteDialog());
      yield put(actions.loadItemsRequest()); // through the list watcher (CREW-1268)
      yield put(
        notify({
          type: "success",
          title: "Success",
          message: "File(s) have been renamed successfully.",
        })
      );
    } catch (e) {
      console.error(e);
      yield put(actions.updateItemError(e));
    }
  }
  
  return [
    takeEvery(constants.RENAME_FILES, renameFiles),
  ];
};


const extendedSagas = (baseSagas, newSagas) => {
  return () => [
    ...baseSagas(),
    ...newSagas
  ];
};

const extendedSelectors = (baseSelectors) => (state) => ({
  ...baseSelectors(state),
  selectedTypes: state[statePropName].selectedTypes,
})

export default {
  extendedConstants,
  extendedActions,
  extendedInitialState,
  extendedActionHandlers,
  extendedSagas,
  newSagas,
  extendedSelectors
};
